import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';

import { CoreModule } from './core/core.module';
import { Environment } from '@elight/client/shared/utility/common';
import { ClientSharedUiThemeModule } from '@elight/client/shared/ui/theme';
import { ClientSharedUtilityStateModule } from '@elight/client/shared/utility/state';
import { ClientFeatureLoginModule } from '@elight/client/feature/login';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { environment } from '../environments/environment';

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        HttpClientModule,
        AppRoutingModule,
        CoreModule,
        BrowserAnimationsModule,
        ClientSharedUiThemeModule,
        ClientSharedUtilityStateModule,
        ClientFeatureLoginModule,
    ],
    providers: [
        {
            provide: Environment,
            useValue: environment,
        },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
